import React, { FC, useMemo } from 'react';

import { IFilterDefinition, OptionType } from '@evinced-private/ui-common';

import { IFilterOptions } from 'src/common/helpers/DataFilterHelper';

import { DASHBOARD_DATE_RANGE_OPTIONS } from '../../constants/DashboardFiltersDefinitions';
import { BaseFilters } from '../base-filters/BaseFilters';

import './DashboardFilters.scss';

interface DashboardFiltersProps {
	filters: IFilterOptions;
	onFilterChange: (filters: IFilterOptions) => void;
	isLoading?: boolean;
	filterDefinitions?: IFilterDefinition[];
	filterOptions?: Record<string, OptionType[]>;
}

export const DashboardFilters: FC<DashboardFiltersProps> = ({
	filters,
	onFilterChange,
	isLoading = false,
	filterDefinitions,
	filterOptions: customFilterOptions
}) => {
	const filterOptions = useMemo(() => {
		// Use custom filter options if provided, otherwise fall back to date range only
		if (customFilterOptions) {
			return customFilterOptions;
		}

		// Fallback to date range only if no custom options provided
		return {
			dateRange: DASHBOARD_DATE_RANGE_OPTIONS
		};
	}, [customFilterOptions]);

	return (
		<BaseFilters
			filters={filters}
			onFilterChange={onFilterChange}
			isLoading={isLoading}
			filterDefinitions={filterDefinitions}
			filterOptions={filterOptions}
			ariaLabel="Dashboard filters"
			skipLinkId="dashboard-filters-section"
			className="dashboard-filters"
		/>
	);
};
